import * as React from 'react';
import AddressButtonComponent from './address-button';

export interface IAddressDeleteActionsProps {
    saveButton?: React.ReactNode;
    cancelButton?: React.ReactNode;
}
export interface IAddressDeleteProps {
    onSave?(): void;
    onCancel?(): void;
}
export const AddressDelete = (props: IAddressDeleteProps): IAddressDeleteActionsProps => {
    const { onCancel, onSave } = props;

    return {
        saveButton: onSave && (
            <AddressButtonComponent
                {...{
                    className: 'msc-address-form__button-save msc-btn',
                    ariaLabel: 'Yes',
                    text: 'Yes',
                    onClick: onSave
                }}
            />
        ),
        cancelButton: onCancel && (
            <AddressButtonComponent
                {...{
                    className: 'msc-address-form__button-cancel msc-btn',
                    text: 'Cancel',
                    ariaLabel: 'no',
                    onClick: onCancel
                }}
            />
        )
    };
};
